// A file name may not be reused for a level 1 resource: it must not collide with any prior
// upload (draft, partially completed or completed — status is irrelevant) nor with the draft
// currently in progress (which has no persisted row yet, so it isn't in `uploads`).
export const isFileNameAlreadyUsed = (
  fileName: string,
  uploads: Array<{ fileName?: string | null }>,
  currentDraftName?: string | null,
): boolean => {
  const usedNames = new Set<string>();
  for (const upload of uploads) {
    if (upload?.fileName) {
      usedNames.add(upload.fileName);
    }
  }
  if (currentDraftName) {
    usedNames.add(currentDraftName);
  }
  return usedNames.has(fileName);
};
